import { useQuery } from '@tanstack/react-query';

import { questionnaireDesignApi } from '../api/questionnaire-design.adapter';

export const questionnaireDesignQueryKeys = {
  all: ['questionnaire-design'] as const,
  questionsForItem: (itemId: string) =>
    [...questionnaireDesignQueryKeys.all, 'questions', itemId] as const,
  allQuestions: () =>
    [...questionnaireDesignQueryKeys.all, 'questions', '__all__'] as const,
};

export function useItemQuestionsQuery(itemId: string | null) {
  return useQuery({
    queryKey: questionnaireDesignQueryKeys.questionsForItem(itemId ?? '__none__'),
    queryFn: () => questionnaireDesignApi.listQuestions(itemId as string),
    // The hook is rendered before an item is picked; guard the fetch so we
    // don't issue an empty request.
    enabled: itemId !== null,
  });
}

// Powers the tree's disease filter dim/count badges. The cost is one fetch
// per session (the staleTime keeps it cached) — well worth it vs N+1 per-item
// queries.
export function useAllQuestionsQuery() {
  return useQuery({
    queryKey: questionnaireDesignQueryKeys.allQuestions(),
    queryFn: () => questionnaireDesignApi.listAllQuestions(),
    staleTime: 30 * 1000,
  });
}
